import '../styles/CustomAuthenticatorStyle.css';

import React from 'react';

import {
  Authenticator,
  Heading,
  useTheme,
  Text,
  View,
  Button,
  useAuthenticator,
} from '@aws-amplify/ui-react';
import { I18n } from 'aws-amplify/utils';
import { translations } from '@aws-amplify/ui-react';
import { useActions } from '../../hooks';
I18n.putVocabularies(translations);
I18n.setLanguage('es');
// I18n.putVocabularies({
//   es: {
//     'Sign In': 'Iniciar Sesión',
//     'Sign Up': 'Regístrate',
//   },
// });
interface CustomAuthenticatorProps {
  // Add your component props here
}

const privacidad = (
  <a
    className="terms_link"
    target="_blank"
    rel="noreferrer"
    href="https://arsient.notion.site/Aviso-de-Privacidad-Integral-de-batuenergy-com-d843f86d0fb24200b3982395a7939e72"
  >
    Aviso de privacidad
  </a>
);
const terms = (
  <a
    className="terms-link"
    target="_blank"
    rel="noreferrer"
    href="https://arsient.notion.site/T-rminos-y-condiciones-edff843d6ef74887b7d09ecc2b0c937b"
  >
    Terminos y condiciones
  </a>
);
const CustomAuthenticator: React.FC<CustomAuthenticatorProps> = (props) => {
  const { userNeedsRegistration } = useActions();
  // Add your component logic here

  const components = {
    Footer() {
      const { tokens } = useTheme();

      return (
        <View textAlign="center" padding={tokens.space.large}>
          <div className="request-bill-form-terms-container">
            Al hacer uso de nuestro servicio aceptas nuestros {terms}. Consulta
            aquí nuestro{privacidad}.
          </div>
        </View>
      );
    },
    SignIn: {
      FormFields() {
        const { toForgotPassword } = useAuthenticator();
        return (
          <View textAlign="center" className="sign-in-footer">
            <Button
              fontWeight="normal"
              onClick={toForgotPassword}
              size="small"
              variation="link"
            >
              Olvidé mi contraseña
            </Button>
          </View>
        );
      },
      Footer() {
        const { toForgotPassword } = useAuthenticator();

        return (
          <View textAlign="center" className="sign-in-footer">
            <Button
              fontWeight="normal"
              onClick={toForgotPassword}
              size="small"
              variation="link"
            >
              Olvidé mi contraseña
            </Button>
          </View>
        );
      },
    },
    SignUp: {
      Header() {
        const { tokens } = useTheme();
        return (
          <Heading
            padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
            level={3}
          >
            !Registrate para usar el producto!
          </Heading>
        );
      },
    },
    ConfirmSignUp: {
      Header() {
        const { tokens } = useTheme();
        return (
          <Heading
            padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
            level={3}
          >
            Enter Information:
          </Heading>
        );
      },
    },
    SetupTotp: {
      Header() {
        const { tokens } = useTheme();
        return (
          <Heading
            padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
            level={3}
          >
            Enter Information:
          </Heading>
        );
      },
    },
    ConfirmSignIn: {
      Header() {
        const { tokens } = useTheme();
        return (
          <Heading
            padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
            level={3}
          >
            Enter Information:
          </Heading>
        );
      },
    },
    ForgotPassword: {
      Header() {
        const { tokens } = useTheme();
        return (
          <Heading
            padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
            level={3}
          >
            Ingresa tu correo para recuperar tu contraseña:
          </Heading>
        );
      },
    },
    ConfirmResetPassword: {
      Header() {
        const { tokens } = useTheme();
        return (
          <Heading
            padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
            level={3}
          >
            Ingresa tu código y nueva contraseña
          </Heading>
        );
      },
      Footer() {
        const { toSignIn } = useAuthenticator();

        return (
          <View textAlign="center">
            <Button
              fontWeight="normal"
              onClick={toSignIn}
              size="small"
              variation="link"
            >
              Volver a inicio de sesión
            </Button>
          </View>
        );
      },
    },
  };
  const formFields = {
    signIn: {
      username: {
        label: 'Correo',
        placeholder: 'correo@batuenergy.com',
      },
      password: {
        label: 'Contraseña',
        placeholder: '************',
      },
    },
    signUp: {
      email: {
        label: 'Correo',
        placeholder: 'correo@batuenergy.com',
        order: 1,
      },
      password: {
        label: 'Contraseña:',
        placeholder: '************',
        order: 2,
      },
      confirm_password: {
        label: 'Confirma tu contraseña:',
        placeholder: '************',
        order: 3,
      },
    },
    forceNewPassword: {
      password: {
        label: 'Contraseña:',
        placeholder: 'Ingresa tu contraseña',
      },
    },
    forgotPassword: {
      username: {
        placeholder: 'correo@batuenergy.com',
        label: 'Correo',
      },
    },
    confirmResetPassword: {
      confirmation_code: {
        placeholder: 'Ingresa tu código',
        label: 'Código de confirmación',
      },
      password: {
        label: 'Contraseña:',
        placeholder: '************',
      },
      confirm_password: {
        label: 'Confirma tu nueva contraseña:',
        placeholder: '************',
      },
    },
    setupTotp: {
      QR: {
        totpIssuer: 'test issuer',
        totpUsername: 'amplify_qr_test_user',
      },
      confirmation_code: {
        label: 'New Label',
        placeholder: 'Enter your Confirmation Code:',
        isRequired: false,
      },
    },
    confirmSignIn: {
      confirmation_code: {
        label: 'New Label',
        placeholder: 'Enter your Confirmation Code:',
        isRequired: false,
      },
    },
  };
  return (
    <div className="custom-auth-container">
      <Authenticator
        formFields={formFields}
        components={components}
        loginMechanisms={['email']}
        hideSignUp={true}
        className="custom-authenticator"
      />
    </div>
  );
};

export { CustomAuthenticator };
